export default "__VITE_ASSET__4hRiszj8__"